class BuyNowButton extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.getAttribute('form'));
    this.button = this.querySelector('button');

    if (!this.form || !this.button) {
      return;
    }

    this.onClick = this.onClick.bind(this);
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  async onClick(event) {
    event.preventDefault();

    if (this.button.getAttribute('aria-busy') === 'true') {
      return;
    }

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.button.setAttribute('aria-busy', 'true');

    try {
      const formData = new FormData(this.form);

      // Buy Now posts directly instead of dispatching a form submit event, so it skips
      // cart-complementary-tracker.js's capture-phase listener — set the same attribute here so the
      // cart drawer's complementary-products section still picks up this product if the customer ends
      // up back in the cart instead of completing checkout (e.g. they hit back from the checkout page).
      const variantId = this.form.elements['id']?.value;

      if (variantId) {
        formData.set('attributes[complementary_last_added_variant]', variantId);
      }

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      window.location.href = `${Shopify.routes.root}checkout`;
    } catch (error) {
      console.error(error);
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!window.customElements.get('buy-now-button')) {
  window.customElements.define('buy-now-button', BuyNowButton);
}
